import { DEFAULT_COLORS } from "./PieChart.styled";

/* eslint-disable react-i18n/no-dynamic-translation-keys */
export const RATINGS_CONFIG = [
  { id: 5, label: "Ausgezeichnet", color: "rgb(39, 221, 139)" },
  { id: 4, label: "Gut", color: "rgb(30, 34, 255)" },
  { id: 3, label: "Durchschnitt", color: "rgb(171, 180, 244)" },
  { id: 2, label: "Weniger geeignet", color: "rgb(250, 185, 0)" },
  { id: 1, label: "Nicht passend", color: "rgb(255, 91, 60)" },
  { id: 0, label: "No info", color: "rgb(124, 124, 126)" }
];

export const ratingsDataTransform = (rawData, t) => {
  return rawData
    .map((item, index) => {
      const rating = RATINGS_CONFIG.find((r) => r.label === item.label);

      if (!rating) {
        return {
          ...item,
          color: "rgb(153, 153, 153)",
          id: rawData.length + index
        };
      }

      const translatedLabel = t ? t(rating.label) : rating.label;
      const starsDisplay = rating.id === 0 ? "☆" : "★".repeat(rating.id);

      return {
        ...item,
        id: rating.id,
        label: `(${starsDisplay}) ${translatedLabel} - ${item.value}`,
        color: rating.color
      };
    })
    .sort((a, b) => {
      if (typeof a.id === "number" && typeof b.id === "number") {
        return b.id - a.id;
      }
      return 0;
    });
};

const CHANNELS_CONFIG = [
  { id: "facebook", label: "Facebook" },
  { id: "linkedin", label: "LinkedIn Anzeige" },
  { id: "linkedin-feed", label: "LinkedIn Feed-Anzeige" },
  { id: "google-search", label: "Google Search" },
  { id: "ebay-kleinanzeigen", label: "Kleinanzeigen" },
  { id: "spotify", label: "Spotify Jobanzeige" },
  { id: "snapchat", label: "Snapchat" },
  { id: "google-display", label: "Google Display Banner" },
  { id: "instagram", label: "Instagram" },
  { id: "youtube", label: "YouTube Banner" },
  { id: "pinterest", label: "Pinterest Boost" },
  { id: "reddit", label: "Reddit" },
  { id: "indeed", label: "Indeed Anzeige" },
  { id: "twitter", label: "X (ehemals Twitter)" },
  { id: "tiktok", label: "TikTok" }
];

export const platformDataTransform = (rawData) => {
  const sortedData = [...rawData].sort((a, b) => {
    if (typeof a.value === "number" && typeof b.value === "number") {
      return b.value - a.value;
    }
    return 0;
  });

  return sortedData.map((item, index) => {
    const channel = CHANNELS_CONFIG.find((r) => r.id === item.label);

    if (!channel) {
      return {
        ...item,
        color: "rgb(153, 153, 153)",
        id: rawData.length + index
      };
    }

    return {
      ...item,
      id: channel.id,
      label: `${channel.label} - ${item.value}`,
      color: DEFAULT_COLORS[index % DEFAULT_COLORS.length]
    };
  });
};
